import React from 'react';

import '../debtPayment.scss';

const BasicText = (props) => {
  return (
    <>
      {props.text.split('\n').map((str, i) => (
        <div
          key={i}
          className={
            'debtpayment-text' +
            (props.bold ? '-bold ' : ' ') +
            (props.classname ? props.classname + ' ' : ' ') +
            (props.color ? props.color : '')
          }>
          {str}
        </div>
      ))}
    </>
  );
};

export default BasicText;
